<script setup>
import HeaderNav from "@/components/headerNav.vue";
import FootNav from "@/components/footNav.vue";
import { ref,   } from 'vue'
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import {useRouter} from "vue-router";
import {getBannerApi, getNewsArticleApi} from "@/api";
import {formatTimestamp} from "@/utils/other";
const bannerList = ref([
]),data = ref({})
const router = useRouter()
let id = router.currentRoute.value.query.id
function  getBanner (){
  getBannerApi({type:6}).then(res => {
    bannerList.value = res.data
  })
}
function getDetails () {
  getNewsArticleApi({id}).then(res => {
    data.value = res.data
  })
}
function goNext (e) {
  if (e) {
    id = e
    getDetails()
  }
}
getBanner()
getDetails()
</script>

<template>
  <div class="box">
    <HeaderNav :isCurrent="5" />
    <div>
      <!-- 轮播图 -->
      <el-carousel height="600px" autoplay>
        <el-carousel-item style="height: auto ;min-height: 600px" v-for="(item ,index) in bannerList" :key="index">
          <img :src="item.picUrl" :alt="item.title">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div>
      <!--主体内容 开始-->
      <div class="product">
        <!--右侧区域 开始-->
        <div id="right">
          <div class="right_title"></div>
          <div class="right_body">
            <div class="info_product_detail_wrap">
              <table class="detail_table" align="center">
                <tbody>
                  <tr>
                    <th>
                      <img src="@/assets/temporary/data/product2.jpg" title="SY75C小型挖掘机" alt="SY75C小型挖掘机" />
                    </th>
                    <td>
                      <div class="InfoTitle"><h1> {{data.title}}</h1></div>
                      <div>{{t('产品ID')}} ：<span class="f2">{{data.info?.productId}}</span></div>
                      <b>{{t('购买价格')}} ：</b><span class="f1">{{data.info?.price}}</span><br/>
                      <div><b>{{t('点击量')}}：</b><span class="InfoHit">{{data.browseCount}}</span></div>
                      <b>{{t('发布时间')}}：</b><span class="InfoTime"> {{formatTimestamp (data.createTime)}}</span><br/>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="ProductDescription">产品描述</div>
            <!-- 频道/文章内容  开始-->
            <div class="InfoSContent"></div>
            <div class="InfoContent">
              <div v-html="data.content">   </div>
              </div>
            <!-- 频道/文章内容  结束-->


            <!-- 当前信息 上一条 下一条  开始-->
            <div class="info_previous_next_wrap">
              <div class="Previous" @click="goNext(data.previousId)">
                <b>{{t('上一条')}}：</b>
                <!-- <a href="" title="">暂无上一条数据</a> -->
                <span class="pointer" v-if="data.previousId">{{data.previousTitle}}</span>
                <span class="pointer" v-else>{{t('暂无上一条数据')}}</span>
              </div>
              <div class="Next" @click="goNext(data.nextId)">
                <b>{{t('下一条')}}：</b>

                <span class="pointer" v-if="data.nextId">{{data.nextTitle}}</span>
                <span class="pointer" v-else>{{t('暂无下一条数据')}}</span>
              </div>
            </div>
            <!-- 当前信息 上一条 下一条  结束-->
          </div>
          <div class="right_bottom"></div>
        </div>
        <!--右侧区域 结束-->
        <div class="clear"></div>
      </div>
      <!--主体内容 结束-->
    </div>
    <div>
      <FootNav />
    </div>
  </div>
</template>
<style scoped lang="scss">
/* 可选：初始隐藏，让动画更明显 */

.InfoTitle_video_a {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}

</style>
